<template>
  <v-card :loading="loading">
    <v-card-title class="px-6">
      <!-- <span class="font-italic  text-h4" style="position: absolute;">#{{ campaign.campaign_id }}</span> -->
      <v-col cols="12 d-flex justify-center align-center font-weight-medium text-h2">
        <v-img
          v-if="
            coupon.image &&
            coupon.image !=
              'https://roadcube-stage-files.s3.eu-central-1.amazonaws.com/images/info/rc/no-image.png'
          "
          contain
          height="150"
          width="150"
          max-height="150"
          max-width="150"
          :src="coupon.image"
          aspect-ratio="1"
          class="grey lighten-2"
        ></v-img>

        <v-icon
          v-else-if="coupon.coupon_id"
          class="ma-5 text-subtitle-1"
          color="secondary"
          size="80"
          v-text="icons.mdiTicketPercentOutline"
        ></v-icon>
        <v-icon
          v-else
          class="ma-5 text-subtitle-1"
          color="secondary"
          size="80"
          v-text="icons.mdiGiftOutline"
        ></v-icon>
        <v-divider class="ma-4" vertical></v-divider>
        <span v-if="coupon.title" class=""> {{ coupon.title }} </span>
        <span v-else-if="reward.reward_points" class=""> {{ translations[storeMode][lang] }} </span>
        <span v-else-if="reward.multi_points_ratio" class="">
          {{ translations[`multi_${storeMode}`][lang] }}
        </span>

        <v-tooltip v-if="showEditRewardButton" color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="ml-8" color="secondary" dark @click="openEditReward">
              <v-icon v-text="icons.mdiPencilOutline"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold">{{ translations.edit[lang] }}</span>
        </v-tooltip>
      </v-col>
    </v-card-title>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr></tr>
          <tr>
            <td>{{ translations.rewardType[lang] }}</td>
            <td>
              <span v-if="coupon.coupon_id" class=""> {{ translations.coupon[lang] }} </span>
              <span v-else-if="reward.reward_points" class="">
                {{ translations[storeMode][lang] }}
              </span>
              <span v-else-if="reward.multi_points_ratio" class="">
                {{ translations[`multi_${storeMode}`][lang] }}
              </span>
            </td>
          </tr>
          <tr v-if="coupon.title">
            <td>{{ translations.title[lang] }}</td>
            <td>{{ coupon.title }}</td>
          </tr>

          <tr v-if="coupon.notification">
            <td>SMS</td>
            <td>
              <v-col v-if="!editSmsDialog" class="ml-0 pl-0 d-flex align-center">
                <span v-html="getMentionableText(coupon.notification[lang])"></span>
                <v-tooltip v-if="showEditButton" color="secondary" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="ml-2 pb-1" @click="editSmsDialog = true">
                      <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                    </v-btn>
                  </template>

                  <span class="font-weight-bold">{{ translations.edit[lang] }}</span>
                </v-tooltip>
              </v-col>
              <v-col v-else class="ml-0 pl-0 d-flex align-center">
                <b-mentionable
                  v-if="editSmsDialog"
                  style="max-width: 800px; width: 100%"
                  :mentionable-items="mentionableItems"
                >
                  <b-textarea
                    style="font-size: 0.99rem"
                    class="pr-0 mentionable-input"
                    v-model="coupon.notification[smsLang]"
                    :label="translations.smsRewardContent[lang]"
                    isSms
                  >
                    <template v-slot:append>
                      <b-lang-menu v-model="smsLang" type="inner"></b-lang-menu>
                    </template>
                  </b-textarea>
                </b-mentionable>
                <v-tooltip color="secondary" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="ml-2 pb-1" @click="saveSms">
                      <v-icon v-text="icons.mdiContentSave"></v-icon>
                    </v-btn>
                  </template>

                  <span class="font-weight-bold">{{ translations.save[lang] }}</span>
                </v-tooltip>
              </v-col>
            </td>
          </tr>
          <tr v-for="(number, index) in campaign.reward.total_numbers" :key="index">
            <td style="width: 50%">
              <span class="font-weight-bold">SMS</span>: {{ number.status }}
            </td>
            <td>
              {{ number.count }}
            </td>
          </tr>
          <tr v-if="coupon.coupon_claim_valid_days">
            <td>{{ translations.couponClaimValidDays[lang] }}</td>
            <td>{{ coupon.coupon_claim_valid_days }}</td>
          </tr>
          <tr v-if="coupon.expiration_date">
            <td>{{ translations.expiration_date[lang] }}</td>
            <td>{{ localizeDate(coupon.expiration_date) }}</td>
          </tr>
          <tr v-if="reward.reward_points">
            <td>{{ translations[`reward_${storeMode}`][lang] }}</td>
            <td>{{ reward.reward_points }}</td>
          </tr>
          <tr v-if="reward.multi_points_ratio">
            <td>{{ translations.multiPointsValue[lang] }}</td>
            <td>x{{ reward.multi_points_ratio }}</td>
          </tr>
          <tr style="background: #eaedf1">
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-row v-if="invoice.store || invoice.company || invoice.both">
      <v-col cols="12" md="12" class="d-flex">
        <span class="text-h5 pa-6 pl-12 pb-0">{{ translations.invoicingSettings[lang] }}</span>
      </v-col>
      <v-col cols="12" md="12" class="">
        <v-row v-if="invoice.both" class="d-flex justify-center transition-all mw-100">
          <v-col cols="12" outlined class="pr-0 pt-0">
            <v-row class="d-flex justify-center transition-all mw-100">
              <v-col cols="12" outlined class="pr-0 pb-0"> </v-col>
            </v-row>
            <v-slider
              v-model="campaign.invoicing_settings.both_percentages.company"
              min="0"
              max="100"
              class="mt-8"
              track-color="green"
              readonly
              thumb-color="secondary"
              hide-details
            >
              <template v-slot:append>
                <v-row class="mt-n12 mxw-150px">
                  <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-0">
                    <v-icon size="70" v-text="icons.mdiStore" color="green"></v-icon>
                  </v-col>
                  <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-1 pt-0 mt-n2">
                    <span class="text-center text-subtitle-2 text--secondary font-weight-light">{{
                      translations.store[lang]
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="12" class="d-flex justify-center pt-0">
                    <b-text-field
                      v-model="storePercentage"
                      :clearable="false"
                      class="mt-n1 pt-0"
                      append-icon="mdi-percent"
                      readonly
                      type="number"
                      style="max-width: 85px"
                    ></b-text-field>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:prepend>
                <v-row class="mt-n12 mxw-150px">
                  <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-0">
                    <v-icon size="70" v-text="icons.mdiDomain" color="orange"></v-icon>
                  </v-col>
                  <v-col cols="12" md="12" class="d-flex justify-center pb-0 mb-1 pt-0 mt-n2">
                    <span class="text-center text-subtitle-2 text--secondary font-weight-light">{{
                      translations.company[lang]
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="12" class="d-flex justify-center pt-0">
                    <b-text-field
                      v-model="campaign.invoicing_settings.both_percentages.company"
                      :clearable="false"
                      class="mt-n1 pt-0"
                      append-icon="mdi-percent"
                      type="number"
                      readonly
                      style="max-width: 85px"
                    ></b-text-field>
                  </v-col>
                </v-row>
              </template>
            </v-slider>
          </v-col>
        </v-row>
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="height: 1px"></th>
                <th class="text-left" style="height: 1px"></th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr>
                <td>{{ translations.charge[lang] }}</td>
                <td>
                  <span v-if="invoice.store" class=""> {{ translations.store[lang] }} </span>
                  <span v-else-if="invoice.company" class="">
                    {{ translations.company[lang] }}
                  </span>
                </td>
              </tr>

              <tr style="background: #eaedf1">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>

      <!-- <v-col cols="12" md="12" class="pa-6" style="background: #eaedf1;"></v-col> -->
    </v-row>
    <v-dialog v-model="editRewardDialog" max-width="1200">
      <b-card
        :title="translations.editReward[lang]"
        :loading="loading"
        :error-message="errorMessage"
        @submit="onSaveEditedReward"
        @cancel="closeEditReward"
      >
        <v-card-text>
          <Step5RewardDraw :editOnly="true" :initialCampaign="campaign" />
        </v-card-text>
      </b-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  mdiClose,
  mdiBell,
  mdiCash,
  mdiGift,
  mdiAccount,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiGiftOutline,
  mdiTicketPercentOutline,
  mdiStore,
  mdiDomain,
  mdiPencilOutline,
  mdiContentSave,
} from '@mdi/js';

import Step5RewardDraw from '@/components/loyaltyPanel/newCampaign/Step5RewardDraw';

import translations from '@/utils/translations/loyaltyPanel/campaigns/viewCampaigns';
import { mapState, mapGetters, mapActions } from 'vuex';
import { mapMutations } from 'vuex/dist/vuex.common.js';

export default {
  name: 'RewardInfo',

  mixins: [translations],
  components: { Step5RewardDraw },

  data: () => ({
    icons: {
      mdiClose,
      mdiBell,
      mdiCash,
      mdiGift,
      mdiAccount,
      mdiCheckCircle,
      mdiCloseCircle,
      mdiGiftOutline,
      mdiTicketPercentOutline,
      mdiStore,
      mdiDomain,
      mdiPencilOutline,
      mdiContentSave,
    },
    onboarding: 0,
    editSmsDialog: false,
    smsLang: '',
    changeSmsElAuto: true,
    changeSmsItAuto: true,
    changeSmsEnAuto: true,
    editRewardDialog: false,
    errorMessage: '',
  }),

  computed: {
    ...mapState(['loading']),
    ...mapState(['superUser']),
    ...mapState('loyaltyPanel/campaigns/newCampaign', ['notificationVariables']),

    lang() {
      return this.$route.params.lang;
    },

    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    ...mapGetters('loyaltyPanel/campaigns/viewCampaigns', ['campaign']),
    ...mapState('loyaltyPanel/campaigns/newCampaign', ['newCampaign']),

    reward() {
      return this.campaign?.reward || {};
    },
    coupon() {
      return this.reward?.coupon || {};
    },
    invoice() {
      return this.campaign.invoicing_settings;
    },
    storePercentage() {
      return 100 - Number(this.invoice?.both_percentages?.company) || 0;
    },
    mentionableItems() {
      return this.notificationVariables.map((e) => ({
        value: e,
        label: this.translations[e]?.lang || e,
      }));
    },
    showEditButton() {
      return ['running', 'activated', 'pending'].includes(this.campaign.status.system);
    },
    showEditRewardButton() {
      return (
        this.superUser && ['running', 'activated', 'pending'].includes(this.campaign.status.system)
      );
    },
    newReward() {
      return this.newCampaign.campaign_reward;
    },
    rewardSystem() {
      let system = null;
      if (this.campaign.reward.coupon?.coupon_id) system = 'coupon';
      else if (this.campaign.reward.multi_points_ratio) system = 'multiplier';
      else if (this.campaign.reward.reward_points > 0) system = 'points';
      else system = 'no_reward';
      return system;
    },
  },
  methods: {
    ...mapMutations(['setNotification']),
    ...mapMutations('loyaltyPanel/campaigns/newCampaign', ['setNewCampaign']),
    ...mapActions('loyaltyPanel/campaigns/newCampaign', ['getNotificationVariables']),
    ...mapActions('loyaltyPanel/campaigns/viewCampaigns', [
      'saveRewardSms',
      'getSingleCampaign',
      'updateReward',
    ]),

    openEditReward() {
      this.campaign.reward.system = this.rewardSystem;
      this.editRewardDialog = true;
    },

    async onSaveEditedReward() {
      this.errorMessage = this.validateNewReward();
      if (this.errorMessage) {
        return;
      }
      let campaign_reward = this.newCampaign.campaign_reward;
      const res = await this.updateReward({
        campaign_id: this.campaign?.campaign_id,
        campaign_reward_id: this.reward?.campaign_reward_id,
        body: { campaign_reward },
      });
      if (res.error) {
        this.setNotification({
          show: true,
          type: 'error',
          text: res.message,
        });
      }
      if (res.data?.campaign_reward) {
        this.campaign.reward = res.data.campaign_reward;
        this.setNotification({
          show: true,
          type: 'success',
          text: this.translations.rewardUpdatedSuccessfully[this.lang],
        });
      }
      this.closeEditReward();
    },
    closeEditReward() {
      this.editRewardDialog = false;
      this.setNewCampaign({});
    },

    next() {
      this.onboarding = this.onboarding + 1 === this.sections.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.sections.length - 1 : this.onboarding - 1;
    },
    localizeDate(date) {
      return date
        ? new Date(date).toLocaleString(this.locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : '';
    },
    saveSms() {
      this.editSmsDialog = false;
      this.saveRewardSms({
        campaign_id: this.campaign?.campaign_id,
        campaign_reward_id: this.reward?.campaign_reward_id,
        body: {
          campaign_reward: {
            notification: this.coupon?.notification,
          },
        },
      });
    },
    getMentionableText(txt) {
      this.mentionableItems.forEach((e) => {
        txt = txt.replaceAll(`{{${e.value}}}`, `<span class="mention-str">${e.value}</span>`);
      });
      return txt;
    },
    validateNewReward() {
      const val = this.newCampaign.campaign_reward || {};

      if (this.rewardSystem == 'no_reward') return '';

      if (this.rewardSystem == 'points') {
        if (/^\d+$/.test(val.reward_points) && Number(val.reward_points) >= 0) return '';
        return this.translations.invalidRewardPoints[this.lang];
      }

      if (this.rewardSystem == 'coupon') {
        const hasGift = val.gift_id !== null && val.gift_id !== undefined && val.coupon_id;
        const days = val.coupon_claim_valid_days ?? val.coupon_claim_valid_days;
        const daysValid =
          days === null || days === undefined || (/^\d+$/.test(String(days)) && Number(days) >= 0);
        if (!daysValid) return this.translations.invalidCouponDays[this.lang];
        if (!hasGift) return this.translations.invalidCoupon[this.lang];
        return '';
      }

      if (this.rewardSystem == 'multiplier') {
        if (val.multi_points_ratio) return '';
        return this.translations.invalidMultiplier[this.lang];
      }
    },
  },
  mounted() {
    this.getNotificationVariables();
    this.smsLang = this.$route.params.lang;
  },
  watch: {
    ['coupon.notification']: {
      handler(val) {
        if (val) {
          let langCapital = this.smsLang[0].toUpperCase() + this.smsLang[1];
          if (this.lang == this.smsLang) {
            if (this.smsLang != 'el' && this.changeSmsElAuto && val.el != val[this.smsLang]) {
              val.el = val[this.smsLang];
            }

            if (this.smsLang != 'it' && this.changeSmsItAuto && val.it != val[this.smsLang]) {
              val.it = val[this.smsLang];
            }

            if (this.smsLang != 'en' && this.changeSmsEnAuto && val.en != val[this.smsLang]) {
              val.en = val[this.smsLang];
            }

            this[`changeSms${langCapital}Auto`] = false;
          } else if (val[this.smsLang] != val[this.lang]) {
            this[`changeSms${langCapital}Auto`] = false;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.mention-str {
  background: #3a4258;
  color: aliceblue;
  padding: 2px 10px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid white;
}

.mentionable-input .v-input {
  font-size: 0.98rem;
  line-height: 1.75rem;
}
</style>
